import React from 'react';
import { SvgIcon, SvgIconProps } from "@mui/material";

export const RecentIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M2.29 11.93A9.9 9.9 0 0 1 12.14 2 9.9 9.9 0 0 1 22 11.93a9.9 9.9 0 0 1-9.86 9.93 9.73 9.73 0 0 1-6.11-2.15 1.07 1.07 0 0 1-.05-1.57 1.16 1.16 0 0 1 1.61 0 7.55 7.55 0 0 0 4.55 1.52 7.69 7.69 0 0 0 7.67-7.73 7.69 7.69 0 0 0-7.67-7.72 7.69 7.69 0 0 0-7.66 7.72h-2.2Z" /><path fill-rule="evenodd" clip-rule="evenodd" d="M10 14.26a1 1 0 0 0 1.5.86l3.02-1.76a1 1 0 0 0 0-1.72L11.5 9.88a1 1 0 0 0-1.5.86v3.52ZM1.65 11a.75.75 0 0 0-.56 1.24l1.85 2.11c.3.35.83.35 1.12 0l1.85-2.1A.75.75 0 0 0 5.35 11h-3.7Z" />
    </SvgIcon>
);
